// Authors: September 2018
// - Luis Booth
// - Willmer Barahona
// - David Nuñez                          🗡
// IT'S DANGEROUS TO GO ALONE! TAKE THIS! 🙌

import axios from 'axios';
import constants from 'js/modules/constants';

const { SUCCESS, ERROR, FAIL, INVALID } = constants.STATUS;
const DataService = {};
const ServiceResponse = {
  code: 0,
  message: '',
  content: {}
};
const currentEnviroment = window._app.results.environment;
const isSandals = window._app.brandOptions.isSandals;
const brandName = isSandals ? 'sandals' : 'beaches';
const accountBaseURL = currentEnviroment === 'TST' ? `https://tstaccountscms.${brandName}.com/api/` : `https://accountscms.${brandName}.com/api/`;

// Timing
axios.interceptors.request.use(config => {

  config.metadata = {
    startTime: new Date()
  };

  return config;

}, error => Promise.reject(error));

axios.interceptors.response.use(response => {

  const { startTime } = response.config.metadata;
  const endTime = new Date();

  response.config.metadata.endTime = endTime;
  response.duration = endTime - startTime;

  // const { status = 'error' } = response.data;

  // const track = {
  //   url: response.config.url,
  //   data: response.config.data,
  //   backendResponse: response.data
  // };


  // if (status === ERROR || status === INVALID) {

  //   console.log('%cQue opinas calamardito?', 'background: url(https://i.pinimg.com/736x/36/ad/a7/36ada7b83fe4398a8b0ba07c53da7bed.jpg) center/contain no-repeat; color: #fff; font-weight: bold; padding: 6rem 1rem 0 1rem;');
  //   console.warn('%cError - Backend Response:', 'font-weight: bold;', track);
  //   window.TrackJS && window.TrackJS.track(Error(`BackEnd Error - : \n${JSON.stringify(track, null, 2)}`));
  // } else if (status === FAIL) {
  //   console.warn('%cFailed - Backend Response:', 'font-weight: bold;', track);
  //   window.TrackJS && window.TrackJS.track(Error(`BackEnd Failed - : \n${JSON.stringify(track, null, 2)}`));
  // }


  return response;

}, error => {

  const { startTime } = error.config.metadata;
  const endTime = new Date();

  console.warn('Something went wrong with the request!');

  error.config.metadata.endTime = endTime;
  error.duration = endTime - startTime;

  window.TrackJS && window.TrackJS.track(error);

  return Promise.reject(error);
});

const getBody = (data) => {

  let body = '';

  Object.keys(data).forEach((key) => {

    body += `${key}=${encodeURIComponent(data[key])}&`;
  });

  body += `subSessionId=${window._app.page.subSessionId}`;

  return body;
};

const getDataFile = async endpoint => {
  let data = null;

  const separator = endpoint.endsWith('/') ? '?' : '&';
  const subSessionId = `${separator}subSessionId=${window._app.page.subSessionId}`;

  try {
    data = axios.get(endpoint + subSessionId, {'Content-Type': 'application/json'});
  } catch(err) {
    data = err;

    window.TrackJS && window.TrackJS.track(err);
  }

  return data;
};

/**
* TODO: Instead of doing a redirect do a page refresh
*/
const returnToHome = () => {
  // window.location.href = '/';
  window.location.reload();
};

const postData = async(endpoint, payload) => {

  const options = {
    headers: {
      'X-CSRFToken': window._app.page.securityToken,
    }
  };
  let deita = null;

  try {
    deita = axios.post(endpoint, getBody(payload), options);
  } catch (err) {
    deita = err;

    window.TrackJS && window.TrackJS.track(err);
  }

  return deita;
};

/**
* Fetch Data
  @code
    -1 - Loading
    0 - Error, Invalid, Fail
    1 - Success
*/

const fetchData = async(options) => {

  const newOptions = {
    endpoint: '',
    payload: null,
    onSuccess: 'Data fetched successfuly!',
    onFail: '',
    onError: 'There was an error trying to get the data',
    // method: METHOD.POST,
    ...options
  };


  const Response = {
    code: 0,
    message: '',
    content: {}
  };

  const {
    endpoint,
    payload,
    onSuccess,
    onFail,
    onError,
  } = newOptions;

  try {

    const datajson = await (
      payload
        ? postData(endpoint, payload)
        : getDataFile(endpoint)
    );

    console.log(`${endpoint} took: ${datajson.duration / 1000}s`);

    if (datajson) {

      const {
        status = 'error',
        message = '',
        data = {},
      } = datajson.data;

      const { invalidFields = {}} = data;
      const invalidFieldsLen = Object.keys(invalidFields).length;

      console.log(data);

      switch(status) {

        case SUCCESS:
          Response.code = 1;
          Response.status = status;
          Response.message = message || onSuccess;
          Response.content = data.result;
          break;

        case FAIL:
          Response.status = status;
          Response.message = message || onFail;
          Response.content = (invalidFieldsLen > 0) ? { invalidFields } : data;

          if (!payload) {
            console.warn(
              'Endpoint should have a payload'
            );
          }

          break;

        case ERROR:
        case INVALID:
          Response.status = status;
          Response.message = message || onError;
          break;

        default:
          Response.status = status;
          Response.message = message || 'onError';
      }
    } else {
      Response.message = onFail;
    }
  } catch(err) {

    console.log('SESSION TIME-OUT');

    Response.message = `${onError}: ${err.message}`;
    Response.content = err;

    returnToHome();
  }

  return Response;
};

// const putData = async(endpoint, payload) => {
//   let deita = null;

//   try {
//     deita = axios.put(endpoint, getBody(payload));
//   } catch (err) {
//     deita = err;
//   }

//   return deita;
// };

DataService.getAllInfo = async endpoint => {
  let datajson = null;
  // const ServiceResponse

  try {
    datajson = await getDataFile(endpoint);

    if (datajson) {
      ServiceResponse.code = 1;
      ServiceResponse.message = 'Data fetched successfuly!';
      ServiceResponse.content = datajson.data.data;
    } else {
      ServiceResponse.message = 'No data fetched';
      ServiceResponse.content = datajson;
    }
  } catch(err) {
    ServiceResponse.message = `There was an error trying to get the data: ${ err.message }`;
    ServiceResponse.content = err;
    returnToHome();
  }

  return ServiceResponse;
};

// DataService.getAvailability = async() => {
//   let datajson = null;

//   try {
//     datajson = await getDataFile('/room-availability/');

//     if (datajson) {
//       ServiceResponse.code = 1;
//       ServiceResponse.message = 'Data fetched successfuly!';
//       ServiceResponse.content = datajson.data.data;
//     } else {
//       ServiceResponse.message = 'No data fetched';
//       ServiceResponse.content = datajson;
//     }
//   } catch(err) {
//     ServiceResponse.message = `There was an error trying to get the data: ${ err.message }`;
//     ServiceResponse.content = err;
//   }

//   return ServiceResponse;
// };

/**
 * 📅 Room Availability
 * ----------------------------------------------
 *  @param {string} Object.rstCode - Resort Code
 *  @param {string} Object.categoryCode - Room Code
 */
DataService.getRoomAvailability = async(params) => {

  const {checkInDate, checkOutDate, resortCode: rstCode = '', categoryCode = ''} = params;

  const parameters = {
    checkInDate,
    checkOutDate,
    rstCode,
    categoryCode
  };

  let datajson = null;

  try {
    datajson = await postData('/read-room-availability/', parameters);

    if (datajson) {
      const { status = 'error', message = '', data = {} } = datajson.data;

      ServiceResponse.status = status;
      ServiceResponse.message = message;
      ServiceResponse.data = data.result;

    } else {
      ServiceResponse.status = 'joh';
      ServiceResponse.message = 'No data fetched';
      ServiceResponse.data = datajson;
    }
  } catch(err) {
    ServiceResponse.status = '';
    ServiceResponse.message = `There was an error trying to get the data: ${ err.message }`;
    ServiceResponse.data = err;
    returnToHome();
  }

  return ServiceResponse;
};

/**
 * 🏨 Get Rooms
 * ----------------------------------------------
 *
 *  @param {Object}  newParameters - All Parameters
 *  @param {string}  newParameters.rstCode - Resort Code
 *  @param {string}  newParameters.checkInDate - Check In Date 'YYYY-MM-DD'
 *  @param {string}  newParameters.checkOutDate - Check Out Date 'YYYY-MM-DD'
 *  @param {number}  newParameters.ssgNumber - SSG Number
 *  @param {boolean} newParameters.airIncluded - Air Flag
 *  @param {number}  [newParameters.adults = 2]
 *  @param {number}  [newParameters.children = 0]
 *  @param {number}  [newParameters.infants = 0]
 */
DataService.getRooms = async(newParameters) => {
  let datajson = null;
  const parameters = {
    adults: 2,
    children: 0,
    infants: 0,
    ...newParameters
  };

  parameters.roomCode = ''; // remove this in the future

  try {
    datajson = await postData('/read-land-availability/', parameters);

    if (datajson) {
      const { status = 'error', message = '', data = {} } = datajson.data;

      ServiceResponse.status = status;
      ServiceResponse.message = message;
      ServiceResponse.data = data.result;

    } else {
      ServiceResponse.message = 'No data fetched';
      ServiceResponse.results = datajson;
    }
  } catch(err) {
    ServiceResponse.message = `There was an error trying to get the data: ${ err.message }`;
    ServiceResponse.results = err;
    returnToHome();
  }

  return ServiceResponse;
};

DataService.getRoomDetails = async({rstCode = '', categoryCode = ''}) => {
  let datajson = null;

  try {
    datajson = await postData('/read-room-details/', {rstCode, categoryCode});

    if (datajson) {
      const { status = 'error', message = '', data = {} } = datajson.data;

      ServiceResponse.status = status;
      ServiceResponse.message = message;
      ServiceResponse.data = data.result;

      // switch (status) {
      //   case success:
      //     ServiceResponse.status = status;
      //     ServiceResponse.message = message || 'Data fetched successfuly!';
      //     ServiceResponse.results = results;
      //     break;

      //   case fail:
      //     ServiceResponse.status = status;
      //     ServiceResponse.message = message || 'You have invalid fields!';
      //     ServiceResponse.results = results;
      //     break;

      //   case error:
      //     ServiceResponse.status = status;
      //     ServiceResponse.message = message || 'Error has ocurred, it could be db, db response or java';
      //     ServiceResponse.results = results;
      //     break;

      //   case invalid:
      //     ServiceResponse.status = status;
      //     ServiceResponse.message = message || 'Please try it again or refresh the window.';
      //     ServiceResponse.results = results;
      //     break;

      //   default:
      //     ServiceResponse.status = 404;
      //     ServiceResponse.message = message || 'This status does not exits';
      //     ServiceResponse.results = results;
      //     break;
      // }

    } else {
      ServiceResponse.message = 'No data fetched';
      ServiceResponse.results = datajson;
    }
  } catch(err) {
    ServiceResponse.message = `There was an error trying to get the data: ${ err.message }`;
    ServiceResponse.results = err;
    returnToHome();
  }

  return ServiceResponse;
};

DataService.saveSSG = async(payload) => {
  const { username, password, recaptchaToken } = payload;
  const response = {...ServiceResponse};
  let datajson = null;

  /*
  {
    code: -1,
    content: {
      name: 'le name',
      memberid: '99999999999',
      availablePoints: 2598500,
      discountAmmount: 2679
    }
  }
  */

  try {
    datajson = await postData('/validate-ssg-member/', { username, password, recaptchaToken });

    if (datajson) {
      const { data, status } = datajson.data;

      if (status === 'success') {
        response.code = 1;
        response.message = 'Login successfull!';
        response.content = data.result;
      } else {
        response.code = 0;
        response.message = 'Login attempt failed';
        response.content = datajson;
      }
    } else {
      response.code = 0;
      response.message = 'Login attempt failed';
      response.content = datajson;
    }
  } catch(err) {
    response.code = 0;
    response.message = `There was an error trying to login to SSG service: ${ err.message }`;
    response.content = err;
    returnToHome();
  }

  return response;
};

DataService.logoutSSG = async() => {
  const fetchResponse = {...ServiceResponse};
  let datajson = null;

  try {
    datajson = await postData('/log-out/', {});

    if (datajson) {
      const { data, status } = datajson.data;

      fetchResponse.code = -1;
      if (status === 'success') {
        /* DO NOT change this message  */
        fetchResponse.message = 'success';
        fetchResponse.content = data;
      } else {
        fetchResponse.message = 'Logout attempt failed';
        fetchResponse.content = datajson;
      }
    } else {
      fetchResponse.message = 'Logout attempt failed';
      fetchResponse.content = datajson;
    }
  } catch(err) {

    fetchResponse.message = `There was an error trying to Logout to SSG service: ${ err.message }`;
    fetchResponse.content = err;
    // returnToHome();
  }

  return fetchResponse;
};

DataService.saveGroup = async(groupCode) => {
  let datajson = null;
  const fetchResponse = {...ServiceResponse};

  try {
    datajson = await postData('/validate-group-code/', { groupCode });

    const { status } = datajson.data;

    console.log(status);

    if (datajson) {
      if (status === 'invalid' || status === 'fail' || status === 'error') {
        fetchResponse.code = 0;
        fetchResponse.message = 'Group code validation attempt failed';
        fetchResponse.content = datajson;
      } else {
        fetchResponse.code = 1;
        fetchResponse.message = 'Group code validation successfull!';
        fetchResponse.content = datajson.data.data;
      }
    } else {
      fetchResponse.code = 0;
      fetchResponse.message = 'Post forgot password attempt failed';
      fetchResponse.content = datajson;
    }
  } catch(err) {
    fetchResponse.code = 0;
    fetchResponse.message = `There was an error trying to login to validate group service: ${ err.message }`;
    fetchResponse.content = err;
    returnToHome();
  }

  console.log(fetchResponse);

  return fetchResponse;
};

DataService.removeGroup = async() => {

  const options = {
    endpoint: '/clear-group-code/'
  };

  return await fetchData(options);

};

DataService.getCountries = async() => {
  const countryArray = [];
  const fetchResponse = {...ServiceResponse};
  let datajson = null;

  try {
    datajson = await getDataFile('/read-countries/');

    if (datajson) {
      if (datajson.data.data.status !== 'invalid' || datajson.data.status === 'fail' || datajson.data.status === 'error') {
        datajson.data.data.result.map(item => {

          // commented this code since region code isn't always present
          //  in data coming from database

          // countryArray.push({
          //   label: item.country,
          //   value: item.countryCode.toLowerCase(),
          //   attrs: {
          //     'data-countryid': item.countryCode.toLowerCase(),
          //     'data-regionid': item.regionCode.toLowerCase()
          //   }
          // });

          countryArray.push({
            label: item.country,
            value: item.countryCode.toLowerCase(),
            attrs: {
              'data-countryid': item.countryCode.toLowerCase(),
            }
          });
        });

        fetchResponse.code = 1;
        fetchResponse.message = 'get countries successfull!';
        fetchResponse.content = countryArray;
      } else {
        fetchResponse.message = 'get countries attempt failed';
        fetchResponse.content = countryArray;
      }
    } else {
      fetchResponse.message = 'get countries attempt failed';
      fetchResponse.content = datajson;
    }
  } catch(err) {
    fetchResponse.message = `There was an error trying to get countries: ${ err.message }`;
    fetchResponse.content = err;
    returnToHome();
  }

  return fetchResponse;
};

DataService.getStates = async(country) => {
  const statesArray = [];
  const fetchResponse = {...ServiceResponse};
  let datajson = null;

  try {
    datajson = await getDataFile(`/read-states/?country=${ country }`);

    if (datajson) {
      if (datajson.data.data.status !== 'invalid') {
        datajson.data.data.result.map(item => {
          statesArray.push({
            label: item.state,
            value: item.stateCode.toLowerCase(),
            attrs: {
              'data-countryid': item.country && item.country.toLowerCase(),
              'data-stateid': item.stateId
            }
          });
        });

        fetchResponse.code = 1;
        fetchResponse.message = 'get states successfull!';
        fetchResponse.content = statesArray;
      } else {
        fetchResponse.message = 'get states attempt failed';
        fetchResponse.content = datajson;
      }
    } else {
      fetchResponse.message = 'get states attempt failed';
      fetchResponse.content = datajson;
    }
  } catch(err) {
    fetchResponse.message = `There was an error trying to get states: ${ err.message }`;
    fetchResponse.content = [];
    returnToHome();
  }

  return fetchResponse;
};

DataService.readSummary = async() => {
  let datajson = null;
  const fetchResponse = {...ServiceResponse};

  try {
    datajson = await getDataFile('/read-summary/');

    if (datajson) {
      if (datajson.data.status === 'invalid' || datajson.data.status === 'fail' || datajson.data.status === 'error') {
        fetchResponse.code = 0;
        fetchResponse.message = 'get summary attempt failed';
        fetchResponse.content = datajson.data;
      } else {
        fetchResponse.code = 1;
        fetchResponse.message = 'get summary successfull!';
        fetchResponse.content = datajson.data.data.result;
      }
    } else {
      fetchResponse.code = 0;
      fetchResponse.message = 'get summary attempt failed';
      fetchResponse.content = datajson;
    }
  } catch(err) {
    fetchResponse.message = `There was an error trying to get summary: ${ err.message }`;
    fetchResponse.content = [];
    returnToHome();
  }

  return fetchResponse;
};

DataService.readTravelInsurance = async() => {
  let datajson = null;
  const fetchResponse = {...ServiceResponse};

  try {
    datajson = await getDataFile('/get-travel-insurance/');

    if (datajson) {
      if (datajson.data.status === 'invalid' || datajson.data.status === 'fail' || datajson.data.status === 'error') {
        fetchResponse.code = 0;
        fetchResponse.message = 'get insurance attempt failed';
        fetchResponse.content = datajson.data;
      } else {
        fetchResponse.code = 1;
        fetchResponse.message = 'get insurance successfull!';
        fetchResponse.content = datajson.data.data.result;
      }
    } else {
      fetchResponse.code = 0;
      fetchResponse.message = 'get insurance attempt failed';
      fetchResponse.content = datajson;
    }
  } catch(err) {
    fetchResponse.message = `There was an error trying to get insurance data: ${ err.message }`;
    fetchResponse.content = [];
    // returnToHome();
  }

  return fetchResponse;
};

DataService.readGateways = async() => {
  // const gatewaysArray = [];
  let datajson = null;
  const fetchResponse = {...ServiceResponse};

  try {
    datajson = await getDataFile('/read-gateways/');

    if (datajson) {
      if (datajson.data.data) {
        if (datajson.data.data.status !== 'invalid') {
          fetchResponse.code = 1;
          fetchResponse.message = 'get gateways successfull!';
          fetchResponse.content = datajson.data.data.result;
        } else {
          fetchResponse.code = 0;
          fetchResponse.message = 'get gateways attempt failed';
          fetchResponse.content = datajson;
        }
      } else {
        fetchResponse.code = 0;
        fetchResponse.message = 'get gateways attempt failed';
        fetchResponse.content = datajson;
      }
    } else {
      fetchResponse.message = 'get gateways attempt failed';
      fetchResponse.content = datajson;
    }
  } catch(err) {
    fetchResponse.message = `There was an error trying to get gateways: ${ err.message }`;
    fetchResponse.content = [];
    returnToHome();
  }

  return fetchResponse;
};

DataService.readResortGateways = async() => {
  let datajson = null;
  const fetchResponse = {... ServiceResponse};

  try {
    datajson = await getDataFile('/read-resort-gateways/');

    if(datajson) {
      if(datajson.data) {
        if(datajson.data.status === 'success') {
          fetchResponse.code = 1;
          fetchResponse.message = 'get resort gateways successfulll!';
          fetchResponse.content = datajson.data.data.result;
        } else {
          fetchResponse.code = 0;
          fetchResponse.message = 'get resort gateways attemp failed';
          fetchResponse.content = datajson;
        }
      }else {
        fetchResponse.code = 0;
        fetchResponse.message = 'get resort gateways attemp failed';
        fetchResponse.content = datajson;
      }
    }else {
      fetchResponse.message = 'get resort gateways attemp failed';
      fetchResponse.content = datajson;
    }
  } catch (err) {
    fetchResponse.message = `There was an error trying to get the resort gateways: ${err.message}`;
    fetchResponse.content = [];
    returnToHome();
  }

  return fetchResponse;
};

DataService.readAirAvailability = async(params) => {
  // /read-air-availability/?rstCode=SMB&departureGateway=JFK&departureDate=2019-03-01&returnDate=2019-03-07&adults=3&children=2&infants=1
  let airAvailabilityArray = [];
  let datajson = null;
  const fetchResponse = {...ServiceResponse};

  try {
    datajson = await getDataFile(`/read-air-availability/${ params }`);

    const { status } = datajson.data;

    if (datajson) {
      if (status === 'invalid' || status === 'fail' || status === 'error') {
        fetchResponse.code = 0;
        fetchResponse.message = 'get flights info attempt failed';
        fetchResponse.content = datajson;
      } else {
        airAvailabilityArray = datajson.data.data.result;
        fetchResponse.code = 1;
        fetchResponse.message = 'get flights info successfull!';
        fetchResponse.content = airAvailabilityArray;
      }
    } else {
      fetchResponse.code = 0;
      fetchResponse.message = 'get flights info attempt failed';
      fetchResponse.content = datajson;
    }
  } catch(err) {
    console.log(err);
    fetchResponse.message = `There was an error trying to get flights info: ${ err.message }`;
    fetchResponse.content = [];
    returnToHome();
  }

  return fetchResponse;
};

DataService.ssgPasswordRecovery = async(params) => {
  let datajson = null;
  const fetchResponse = {
    code: 0,
    message: '',
    content: {},
    status: ''
  };

  try {
    datajson = await postData('/forgot-password/', params);

    const { status } = datajson.data;

    console.log(status);

    if (datajson) {
      if (status === 'fail') {

        fetchResponse.code = 0;
        fetchResponse.message = 'Post forgot password attempt failed';
        fetchResponse.content = datajson;
        fetchResponse.status = 'fail';
      } else {
        fetchResponse.code = 1;
        fetchResponse.message = 'Post forgot password successfull!';
        fetchResponse.content = datajson.data.result;
        fetchResponse.status = 'success';
      }
    } else {
      fetchResponse.code = 0;
      fetchResponse.message = 'Post forgot password attempt failed';
      fetchResponse.content = datajson;
      fetchResponse.status = status;
    }
  } catch(err) {
    console.log(err);
    fetchResponse.code = 0;
    fetchResponse.message = `There was an error trying to post forgot password info: ${ err.message }`;
    fetchResponse.content = [];
    returnToHome();
  }

  return fetchResponse;
};

DataService.readPaymentPlans = async() => {
  let datajson = null;
  const fetchResponse = {...ServiceResponse};

  try {
    datajson = await getDataFile('/read-payment-plans/');

    const { status } = datajson.data;

    if (datajson) {
      if (status === 'invalid' || status === 'fail' || status === 'error') {

        fetchResponse.code = 0;
        fetchResponse.message = 'Payment plans attempt failed';
        fetchResponse.content = datajson.data;
      } else {
        fetchResponse.code = 1;
        fetchResponse.message = 'Payment plans successfull!';
        fetchResponse.content = datajson.data.data.result;
      }
    } else {
      fetchResponse.code = 0;
      fetchResponse.message = 'Payment plans attempt failed';
      fetchResponse.content = datajson.data;
    }
  } catch(err) {
    console.log(err);
    fetchResponse.code = 0;
    fetchResponse.message = `There was an error info: ${ err.message }`;
    fetchResponse.content = [];
  }

  return fetchResponse;
};

DataService.readCompare = async() => {

  const options = {
    endpoint: '/read-resort-compare/'
  };

  return await fetchData(options);
};

DataService.processDetails = async(fields) => {

  const options = {
    endpoint: '/submit-details/',
    payload: {...fields},
    onSuccess: 'Submit details successfull!',
    // onFail: 'Submit details attempt failed',
    onError: 'There was an error trying to process your request',
  };

  return await fetchData(options);
};

DataService.applySSGPoints = async(fields) => {

  const options = {
    endpoint: '/apply-ssg-points/',
    payload: {...fields},
    onSuccess: 'SSG points successfull!',
    // onFail: 'SSG points attempt failed',
    onError: 'There was an error trying to process your request',
  };

  return await fetchData(options);
};

DataService.ssgUserRecovery = async(fields) => {
  const options = {
    endpoint: '/forgot-username/',
    payload: {...fields},
    onSuccess: 'SSG username successfull!',
    // onFail: 'SSG username attempt failed',
    onError: 'There was an error trying to process your request',
  };

  return await fetchData(options);
};


DataService.readVacationPlanner = async() => {

  const options = {
    endpoint: '/vacation-planner/',
    onSuccess: 'Vacation Planner successfull!',
    // onFail: 'Vacation Planner attempt failed',
    onError: 'There was an error trying to process your request',
  };

  return await fetchData(options);
};

DataService.updateGuestCount = async(fields) => {

  const options = {
    endpoint: '/update-guest-count/',
    payload: {...fields},
    onSuccess: 'Update Guest successfull!',
    onFail: 'Update Guest attempt failed',
    onError: 'There was an error trying to process your request',
  };

  return await fetchData(options);
};

DataService.updateQuiqSessionHandle = async(quiqSessionHandle) => {

  const options = {
    endpoint: '/save-quiq-session-handle/',
    payload: {quiqSessionHandle},
    onSuccess: 'Update Quiq Session Handle successfull!',
    onFail: 'Update Quiq Session Handle attempt failed',
    onError: 'There was an error trying to process your request',
  };

  return await fetchData(options);
};

DataService.submitPromoCode = async(fields) => {

  const options = {
    endpoint: '/read-promo-code/',
    payload: {...fields},
    onSuccess: 'Submit Promo successfull!',
    onFail: 'Invalid Promo Code.',
    onError: 'There was an error trying to process your request',
  };

  return await fetchData(options);
};

DataService.updateNavigation = async(sequenceId) => {

  const options = {
    payload: { sequenceId },
    endpoint: '/navigation-update/',
    onSuccess: 'Navigation updated successfully!',
    // onFail: 'Vacation Planner attempt failed',
    onError: 'There was an error trying to update the navigation',
  };

  return await fetchData(options);
};

DataService.logFE = async(payload) => {

  const options = {
    payload,
    endpoint: '/logFE/',
  };

  return await fetchData(options);
};

/* ***************** UPLIFT ACTIVE JSON ******************** */
DataService.isUpliftActiveByBrand = async() => {
  const disclaimerURL =
      'https://cdn.sandals.com/obe/v12/resources/qobe/uplift-active.json';
  const accountStatus = await fetch(disclaimerURL).then(
    (response) => response.json()
  );

  return accountStatus;
};

/* ❌❌❌ Process ❌❌❌ */

DataService.processVacation = async(fields, guestInfo) => {

  const payload = {
    guestInfo: JSON.stringify(guestInfo),
    ...fields,
  };

  const options = {
    payload,
    endpoint: '/process-vacation/',
    onSuccess: 'Vacation process successfull!',
    // onFail: 'Vacation processing attempt failed',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.processRoom = async(payload) => {

  const options = {
    payload,
    endpoint: '/process-room/',
    onSuccess: 'Room process successfull!',
    // onFail: 'Room processing attempt failed',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.processFlights = async(payload) => {

  const options = {
    payload,
    endpoint: '/process-flights/',
    onSuccess: 'Flight process successfull!',
    // onFail: 'Flight processing attempt failed',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.processItineraries = async(payload) => {

  const options = {
    payload,
    endpoint: '/process-itineraries/',
    onSuccess: 'Flight itinerary process successfull!',
    // onFail: 'Flight itinerary processing attempt failed',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.processGuests = async(payload) => {

  const options = {
    payload,
    endpoint: '/process-guests/',
    onSuccess: 'Guests process successfull!',
    // onFail: 'Guests processing attempt failed',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.processPayment = async(payload, additionalParams) => {

  const stringified = JSON.stringify({
    cc: payload,
  });

  const options = {
    payload: {
      parameters: stringified,
      ...additionalParams
    },
    endpoint: '/process-payment/',
    onSuccess: 'Payment process successfull!',
    // onFail: 'Payment processing attempt failed',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.resetSession = async() => {

  const options = {
    payload: {},
    endpoint: '/session_reset/',
    onSuccess: 'Reset Session successfull!',
    // onFail: 'Reset Session attempt failed',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.storeDataInSession = async(payload) => {

  const options = {
    payload,
    endpoint: '/save-temporal-data/',
    onSuccess: 'Data Stored In Session',
    onFail: 'Data could not be stored',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.updateVacationDetails = async(payload) => {

  const options = {
    payload,
    endpoint: '/update-vacation-details/',
    onSuccess: 'Vacation details updated',
    onFail: 'Vacation details could not be updated',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

DataService.updateBypassUse = async() => {

  const options = {
    endpoint: '/update-bypass-used/',
    onSuccess: 'Bypass updated',
    onFail: 'Bypass could not be updated',
    onError: 'Integration layer error!😱',
  };

  return await fetchData(options);
};

/* *************** ACCOUNTS ENDPOINTS  ****************** */

DataService.isAccountServicesActive = async() => {
  const disclaimerURL =
      'https://cdn.sandals.com/obe/v12/resources/qobe/sandals-account-active.json';
  const accountStatus = await fetch(disclaimerURL).then(
    (response) => response.json()
  );

  return accountStatus;
};

DataService.getPrimaryAccount = async() => {
  const config = {};

  config.method = 'GET';
  config.timeout = 120000;
  config.url = `${accountBaseURL}loyalty/profiles`;
  config.withCredentials = true;

  let response = null;

  await axios(config).then(res => {
    response = res;
  })
    .catch(error => {
      response = error;
    });

  const {
    data = {},
  } = response;

  return data;
};

DataService.loginToAccounts = async(userData) => {
  let response = null;

  const loginData = {
    username: userData.email,
    password: userData.password,
    staySignedIn: userData.staySignedIn,
    recaptcha: userData.captcha
  };

  const config = {};

  config.method = 'POST';
  config.timeout = 120000;
  config.url = `${accountBaseURL}auth/sign-in/`;
  config.withCredentials = true;
  config.data = loginData;

  await axios(config).then(res => {
    response = res;
  })
    .catch((error) => {
      response = error;
    });

  const { data = {} } = response;

  return data;
};

DataService.signOutAccounts = async() => {
  const config = {};

  config.method = 'GET';
  config.timeout = 120000;
  config.url = `${accountBaseURL}auth/sign-out`;
  config.withCredentials = true;

  let response = null;

  await axios(config).then(res => {
    response = res;
  })
    .catch(error => {
      response = error;
    });

  const {
    data = {},
  } = response;

  return data;
};

DataService.getAccountStrapiData = async() => {
  const config = {};

  config.method = 'GET';
  config.timeout = 120000;
  config.url = `${accountBaseURL}layout`;
  config.withCredentials = true;

  let response = null;

  await axios(config).then(res => {
    response = res;
  })
    .catch(error => {
      response = error;
    });

  const {
    data = {},
  } = response;

  return data;
};

DataService.getAccountPoints = async() => {
  const config = {};

  config.method = 'GET';
  config.timeout = 120000;
  config.url = `${accountBaseURL}loyalty/points`;
  config.withCredentials = true;

  let response = null;

  await axios(config).then(res => {
    response = res;
  })
    .catch(error => {
      response = error;
    });

  const {
    data = {},
  } = response;

  return data;
};

DataService.getAccountsSessionValidation = async(password) => {
  let response = null;

  const loginData = {
    password: password,
  };

  const config = {};

  config.method = 'POST';
  config.timeout = 120000;
  config.url = `${accountBaseURL}auth/check-session/`;
  config.withCredentials = true;
  config.data = loginData;

  await axios(config).then(res => {
    response = res;
  })
    .catch((error) => {
      response = error;
    });

  const { data = {} } = response;

  return data;
};

DataService.setSandalsAccountCookie = async(payload) => {
  const { accountNumber, title, gender, firstName, lastName, address1, address2, city, state,
    country, zipCode, phoneNumber, tier, email, points, dateOfBirth } = payload;
  const response = {...ServiceResponse};
  let datajson = null;

  try {
    datajson = await postData('/read-sandals-account/', { accountNumber, title, gender, firstName, lastName, address1, address2, city, state,
      country, zipCode, phoneNumber, tier, email, points, dateOfBirth });

    if (datajson) {
      const { data, status } = datajson.data;

      if (status === 'success') {
        response.code = 1;
        response.message = 'Process Sandals Account Cookie successfull!';
        response.content = data.result;
      } else {
        response.code = 0;
        response.message = 'Process Sandals Account Cookie attempt failed';
        response.content = datajson;
      }
    } else {
      response.code = 0;
      response.message = 'Process Sandals Account Cookie attempt failed';
      response.content = datajson;
    }
  } catch(err) {
    response.code = 0;
    response.message = `There was an error trying to process the Sandals Account service: ${ err.message }`;
    response.content = err;
    returnToHome();
  }

  return response;
};


export default DataService;



// WEBPACK FOOTER //
// ./js/modules/dataservice.js